import React from 'react';
import styles from './RoleManagement.module.css';

const RolePagination = ({
    currentPage,
    totalPages,
    rowsPerPage,
    totalRecords,
    rolesLength,
    onPageChange,
    onRowsPerPageChange
}) => {
    return (
        <div className={styles.pagination}>
            <div className={styles.rowsPerPage}>
                <span>Rows per page</span>
                <select
                    className={styles.rowsSelect}
                    value={rowsPerPage}
                    onChange={onRowsPerPageChange}
                >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
            </div>
            <div className={styles.pageInfo}>
                Showing {rolesLength > 0 ? ((currentPage - 1) * rowsPerPage + 1) : 0} to {Math.min(currentPage * rowsPerPage, totalRecords)} of {totalRecords} results
            </div>
            <div className={styles.pageControls}>
                <button className={styles.pageButton} onClick={() => onPageChange(1)} disabled={currentPage === 1}>««</button>
                <button className={styles.pageButton} onClick={() => onPageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1}>‹</button>
                <span className={styles.pageNumber}>Page {currentPage} of {totalPages || 1}</span>
                <button className={styles.pageButton} onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages || totalPages === 0}>›</button>
                <button className={styles.pageButton} onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages || totalPages === 0}>»»</button>
            </div>
        </div>
    );
};

export default RolePagination;